import { render, staticRenderFns } from "./OperaCouponTemplateWindow.vue?vue&type=template&id=951a46ac&scoped=true"
import script from "./OperaCouponTemplateWindow.vue?vue&type=script&lang=js"
export * from "./OperaCouponTemplateWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaCouponTemplateWindow.vue?vue&type=style&index=0&id=951a46ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951a46ac",
  null
  
)

export default component.exports